require('src/creative/core-page/editorial-review-carousel/editorial-review-carousel');
require('src/creative/core-page/editorial-review-drawer/editorial-review-drawer');


//////////////////
// WEBPACK FOOTER
// ./src/creative/core-page/editorial-review/editorial-review.js
// module id = 160
// module chunks = 1 6 28